// extracted by mini-css-extract-plugin
module.exports = {"header":"x_M d_g","logo":"x_N"};